// options can include:
// refetch: 1
export async function getProfileDetail(profileId, options = {}) {
  if (!profileId) {
    throw 'Profile ID not specified'
  }
  const params = new URLSearchParams(options)
  const url = `${import.meta.env.VITE_TOOLKIT_URL}/content_profile/profile/${profileId}?${params.toString()}`
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  })
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}

// options can include
// refetch: 1
export async function getProfiles(options = {}) {
  const params = new URLSearchParams(options)
  const url = `${import.meta.env.VITE_TOOLKIT_URL}/content_profile/profiles?${params.toString()}`
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  })
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}

export async function updateAccountProfileId({ userUuid, profileId }) {
  const url = `${import.meta.env.VITE_TOOLKIT_URL}/content_profile/update_account`
  const data = JSON.stringify({ user_uuid: userUuid, content_profile_id: profileId })
  const headers = new Headers({
    'Content-Type': 'application/json'
  })
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: data,
    credentials: 'include'
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}
